<template>
  <div class="wrapper" :class="bodyClass">
    <Sidebar />
    <div id="content">
      <NavBar />
      <slot />
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/layout/NavBar.vue'
import Sidebar from '@/components/layout/Sidebar.vue'

export default {
  name: 'DefaultLayout',
  components: {
    NavBar,
    Sidebar
  },
  props: {
    bodyClass: {
      type: String,
      default: ''
    },
    activeSidebar: {
      type: String,
      default: ''
    }
  }
}
</script>
